import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { MaturityListComponent } from './maturity-list/maturity-list.component'

export const maturityRoutes: Route[] = [
  {
    path: 'maturities',
    component: MaturityListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'maturities/:id/edit',
    redirectTo: 'maturities/:id',
    pathMatch: 'full'
  },
  {
    path: 'maturities/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Maturity',
        nameSingular: 'Maturity',
        namePlural: 'Maturities',
        path: 'maturities',
        slug: 'taxonomies/maturities',
        title: 'Maturities'
      }),
      permission: 'readTaxonomies'
    }
  }
]
